import classnames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { cancelDraft } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: ['p12', 'text-center', 'mt12', 'fs14', 'is-full-width'],
    transition: 'all 0.3s',
  },
});

const CancelButtonComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <button
      className={classnames(classes.button, 'smart-maps-button-danger')}
      type="button"
      onClick={() => dispatch(cancelDraft())}>
      <span>Annuler</span>
    </button>
  );
});

CancelButtonComponent.displayName = 'CancelButtonComponent';

export default CancelButtonComponent;
